import { Skeleton } from 'antd';
import { useEffect, useState } from 'react';

export function DataTableSkeleton({
  hideHeader = false,
  headerBg = false,
}: {
  hideHeader?: boolean;
  headerBg?: boolean;
}) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Detect small screen on client-side
  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 640px)'); // Tailwind's sm
    const update = () => setIsSmallScreen(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  const columnsToShow = isSmallScreen ? 2 : 5;

  return (
    <>
      {!hideHeader && (
        <div className="mb-4 px-4 sm:px-0">
          {/* Left header */}
          <div className="mb-4">
            <Skeleton.Input
              active
              size="default"
              className="w-full max-w-xs h-7 rounded-lg bg-primary/20"
            />
          </div>

          {/* Right header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 w-full">
            <Skeleton.Input
              active
              size="default"
              className="w-full sm:w-32 h-11 rounded-lg mb-2 sm:mb-0"
            />
            <Skeleton.Input active size="default" className="w-full sm:w-60 h-11 rounded-lg" />
          </div>
        </div>
      )}

      <div
        className="relative mt-4 border rounded-xl h-[500px] flex flex-col animate-pulse overflow-hidden"
        style={{
          borderColor: '#f0f0f0',
          backgroundColor: headerBg ? '#fafafa' : 'transparent',
        }}
      >
        {/* Sticky header */}
        <div
          className="sticky top-0 z-10 flex flex-wrap border-b bg-white px-4"
          style={{ borderColor: '#f0f0f0', backgroundColor: headerBg ? '#fafafa' : '#fff' }}
        >
          {[...Array(columnsToShow)].map((_, i) => (
            <div key={i} className="px-2 py-4 min-w-[120px]">
              <Skeleton.Input active size="default" className="w-full h-6 rounded-md" />
            </div>
          ))}
        </div>

        {/* Center loading indicator */}
        <div className="absolute top-8 left-0 right-0 z-20 w-full flex flex-col items-center justify-center h-[500px] opacity-75">
          <Skeleton.Avatar active size={80} shape="square" className="mb-4" />
          <Skeleton.Input active size="default" className="w-64 h-7 rounded-lg" />
        </div>
      </div>
    </>
  );
}
